import { useCallback, useReducer } from "react";
import { railNodesFromPoints } from "./railPathEditing";

function drawingReducer(state, action) {
  if (action.type === "start") return { drawing: action.drawing, undone: [] };
  if (!state.drawing) return state;
  const points = state.drawing.points;
  let nextPoints;
  let undone = state.undone;
  switch (action.type) {
    case "add":
      nextPoints = [...points, railNodesFromPoints([action.point])[0]];
      undone = [];
      break;
    case "update":
      if (!points.length) return state;
      nextPoints = [...points.slice(0, -1), { ...points[points.length - 1], ...action.patch }];
      undone = [];
      break;
    case "undo":
      if (!points.length) return state;
      nextPoints = points.slice(0, -1);
      undone = [...undone, points[points.length - 1]];
      break;
    case "redo":
      if (!undone.length) return state;
      nextPoints = [...points, undone[undone.length - 1]];
      undone = undone.slice(0, -1);
      break;
    default:
      return state;
  }
  return { drawing: { ...state.drawing, points: nextPoints }, undone };
}

// Unfinished points have their own history; undoing them must not undo a saved
// rail, a stitch setting, or another layer. Curved nodes keep both handles.
export function useRailDrawing() {
  const [state, dispatch] = useReducer(drawingReducer, { drawing: null, undone: [] });
  const setDrawing = useCallback((drawing) => dispatch({ type: "start", drawing }), []);
  const addPoint = useCallback((x, y) => dispatch({ type: "add", point: { x, y } }), []);
  const updateLastPoint = useCallback((patch) => dispatch({ type: "update", patch }), []);
  const undo = useCallback(() => dispatch({ type: "undo" }), []);
  const redo = useCallback(() => dispatch({ type: "redo" }), []);
  return { drawing: state.drawing, setDrawing, addPoint, updateLastPoint, undo, redo,
    canUndo: !!state.drawing?.points.length, canRedo: !!state.drawing && state.undone.length > 0 };
}
